import {all, takeLatest, put} from 'redux-saga/effects';
import {steveDataStorage} from '../../helpers/sdk-helpers';
import {
  LOAD_HELP_INTRO_DATA,
  LOAD_TOOLTIPS_DATA,
  SET_TOOLTIPS_DATA,
  SET_TOOLTIP_STEP,
  SKIP_TOOLTIPS,
  TOOLTIPS_SKIPPED,
  GOT_IT_CLICKED,
  SET_HELP_INTRO_DATA,
  CHANGE_HELP_INTRO_DATA,
} from './constants';

function* loadTooltipsData() {
  const tooltipsData = steveDataStorage('tooltips', 'status').get('state');
  if (!tooltipsData) {
    return;
  }
  yield put({
    type: SET_TOOLTIPS_DATA,
    steps: tooltipsData.steps,
    skipped: tooltipsData.skipped,
  });
}

function* loadHelpIntroData() {
  const isDisabled = steveDataStorage('onboarding', 'isHelpIntroDisabled', false).get('isDisabled');
  yield put({
    type: SET_HELP_INTRO_DATA,
    data: isDisabled,
  });
}

function* changeTooltipStep({page, steps}) {
  const tooltipsState = {
    skipped: false,
    steps: {
      ...steps,
      [page]: steps[page] + 1,
    },
  };
  steveDataStorage('tooltips', 'status').set(tooltipsState, 'state');
  yield put({
    type: SET_TOOLTIP_STEP,
    page,
    step: steps[page] + 1,
  });
}

function* changeHelpIntroData({value}) {
  steveDataStorage('onboarding', 'isHelpIntroDisabled', false).set(value, 'isDisabled');
  yield put({
    type: SET_HELP_INTRO_DATA,
    data: value,
  });
}

function* tooltipsSkip({steps}) {
  const tooltipsState = {
    skipped: true,
    steps,
  };
  steveDataStorage('tooltips', 'status').set(tooltipsState, 'state');
  yield put({type: SKIP_TOOLTIPS});
}

export default function* dashboardSaga() {
  yield all([
    takeLatest(GOT_IT_CLICKED, changeTooltipStep),
    takeLatest(TOOLTIPS_SKIPPED, tooltipsSkip),
    takeLatest(LOAD_TOOLTIPS_DATA, loadTooltipsData),
    takeLatest(LOAD_HELP_INTRO_DATA, loadHelpIntroData),
    takeLatest(CHANGE_HELP_INTRO_DATA, changeHelpIntroData),
  ]);
}
